import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { formatMoney } from '../api/utils';

const PriceI18NHOC = (C) => {
  class PriceComponent extends Component {
    static getI18NProps(price, salesMarket, prefix) {
      const {amount} = price;
      let buffAmount = formatMoney(amount,
        2,
        ',',
        '.');

      // CH(756), US(860) and UK(826) markets have a different formatting.
      if (salesMarket === '756' || salesMarket === '840' || salesMarket === '826') {
        buffAmount = formatMoney(amount,
          2,
          '.',
          ',');
      }
      return {
        amount: buffAmount,
        currencyCode: price.currencyCode,
        prefix,
      };
    }

    render() {
      return (
        <C price={PriceComponent.getI18NProps(this.props.price,
          this.props.salesMarket, this.props.prefix)}
        />
      );
    }
  }

  PriceComponent.PropTypes = {
    price:PropTypes.shape({
      amount:PropTypes.number.isRequired,
      currencyCode:PropTypes.string.isRequired,
    }).isRequired,
    salesMarket:PropTypes.string,
    prefix: PropTypes.string,
  };

  // Need salesMarket (language) to format correct.
  function mapStateToProps(state) {
    return {
      salesMarket: state.orderAppState.salesMarket,
    };
  }

  return connect(mapStateToProps)(PriceComponent);
};

export default PriceI18NHOC;

